import React from 'react';

import { inputIconPropsType, inputIconType } from '../types';
import { IconNameType } from '../../Icon/types';

import * as S from '../styles';
import { ICONS } from '../../Icon/svgComponents';
import { Icon } from '../../Icon';

const InputIcon = ({ disabled, icon, size, isFocus }: inputIconPropsType): inputIconType => {
    if (typeof icon === 'string' && ICONS[icon as IconNameType]) {
        return <Icon type="actionable" focused={isFocus} disabled={disabled} size={size} name={icon as IconNameType} />;
    }

    if (typeof icon === 'string') {
        return (
            <S.ImgIcon>
                <S.Img src={icon as IconNameType} alt="icon" />
            </S.ImgIcon>
        );
    }

    if (typeof icon === 'function') {
        return icon();
    }

    return null;
};

export default InputIcon;
